<template>
  <div class="checkout-address-form">
    <div class="row">
      <div class="col-md-12">
        <b-form-group label="Documents:" label-cols-sm="1" data-cy="inquiry-file-upload">
          <file-upload
              v-model="files"
          ></file-upload>
        </b-form-group>
        <template v-if="inquiryFiles && inquiryFiles.length">
          <b-card-body class="p-0">
            <!-- TODO: should be b-card-header -->
            <label for="customer-dropdown" class="mb-1 mt-2">Inquiry Files:</label>
            <div v-for="(fileItem, index) in inquiryFiles" :key="fileItem.Id">
              <div style="display:grid" stacked>
                <b-card no-body>
                  <b-card-header>
                    {{ fileItem.Name }}
                    <b-button-toolbar class="float-md-right">
                      <b-button-group size="sm">
                        <b-button clas="p-0" title="Remove File" variant="link"
                          @click.stop="removeFileAt(index)"
                        >
                        <b-icon-trash variant="danger" />
                        </b-button>
                      </b-button-group>
                    </b-button-toolbar>
                  </b-card-header>
                  <b-card-body class="rounded border p-2">
                    <b-container fluid>
                      <b-row>
                        <b-col class="pt-1" md="10">
                          <b-link title="View/Download File" :href="`/api/inquiry/document/${fileItem.Id}/${fileItem.Name}?h=${fileItem.Hash}`" target="_blank">
                            <b-icon icon="file-earmark-arrow-down" /> view/download
                          </b-link>
                          ({{ fileSize(fileItem.Size) }})
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-card-body>
                </b-card>
              </div>
            </div>
          </b-card-body>
        </template>
        <div
          class="form-group row"
          v-for="(comment, index) in comments"
          :key="comment.key"
        >
          <div class="col-md-12" data-cy="inquiry-comments">
            <input
              type="text"
              :id="'street-address-' + comment.key"
              class="form-control mt-3"
              v-model.trim="comments[index].value"
              :placeholder="'Comment Line ' + (index + 1)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { IOrderComment, IOrderDocument } from '@/store/orders/types'
import { Component, Mixins } from 'vue-property-decorator'
import MxSite from '@/mixins/site'
import FileUpload from '@/components/utility/file-upload.vue'

@Component({
  components: {
    'file-upload': FileUpload,
  },
})
export default class OrderComments extends Mixins(MxSite) {
  public files: File[] = []
  public lineId = 0
  public inquiryFiles: IOrderDocument[] = []

  public comments: IOrderComment[] = [
    { key: 'line1', value: '' },
    { key: 'line2', value: '' },
    { key: 'line3', value: '' },
  ]

  public populateComments(comments: string[]) {
    this.comments = [
      { key: 'line1', value: '' },
      { key: 'line2', value: '' },
      { key: 'line3', value: '' },
    ]
    for (let i = 0; i < comments.length; i++) {
      this.comments[i] = { key: 'line' + this.lineId++, value: comments[i] }
    }
  }

  public validate() {
    return {
      'comments': this.comments,
      'files': this.files,
      'inquiryFiles': this.inquiryFiles,
    }
  }

  public populateFiles(files: IOrderDocument[]) {
    if (files && files.length) {
      this.inquiryFiles = files
    }
  }

  public fileSize(size: number): string {
    if (!+size) return '0 bytes'
    const decimals = 2
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['bytes', 'kb', 'mb']
    const i = Math.floor(Math.log(size) / Math.log(k))

    return `${parseFloat((size / Math.pow(k, i)).toFixed(dm))}${sizes[i]}`
  }

  public removeFileAt(index: number) {
    this.inquiryFiles = this.inquiryFiles.filter((s, i) => i !== index)
  }
}
</script>

<style scoped></style>
